import { observable, action, toJS, computed } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { message } from "antd"

export default class Store {
  @observable tableData = []
  @observable timingTaskData = []
  @observable taskDetailData = {}
  @observable totalCount = 0
  @observable detailId = ''
  @observable queryMap = {
    field: 0,
    start: null,
    end: null,
    offset: 0,
    limit: 10,
  }

  @action updatePageIndex = index => this.currentPageIndex = index

  @action setDetailDataId = (id) => {
    this.detailId = id
  }

  @action downloadDetailData = () => {
    return request.get(`${config.backend}/pgs/reports/statistics/jobs/${this.detailId}/excel`)
      .checkToken()
      .commonDispose()
  }

  @action getTimingTaskData = () => {
    return request.get(`${config.backend}/pgs/reports/statistics/result`)
      .query(this.processQueryMap)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.timingTaskData = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action filterTimingTaskData = (newQueryMap) => {
    this.timingTaskData = []
    this.updateQueryMap(newQueryMap)
    return this.getTimingTaskData()
  }

  @action getTableData = () => {
    let limit = this.queryMap.limit, offset = this.queryMap.offset
    return request.get(`${config.backend}/pgs/reports/statistics/jobs?limit=${limit}&offset=${offset}`)
      .checkToken()
      .dataListDispose()
      .then(
        res => {
          this.totalCount = res.totalCount
          this.tableData = res.dataList
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action getDetailData = (id) => {
    return request.get(`${config.backend}/pgs/reports/statistics/jobs/${id}`)
      .query(this.processQueryMap)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.taskDetailData = res
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action createStatisticsJobs = () => {
    if (this.queryMap.start === null || this.queryMap.start === '' || this.queryMap.start === undefined) {
      return message.error('日期不能为空')
    }
    return request.post(`${config.backend}/pgs/reports/statistics/jobs`)
      .send({
        startTime: this.queryMap.start,
        endTime: this.queryMap.end
      })
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.getTableData()
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @computed get processQueryMap() {
    const resule = toJS(this.queryMap)
    return resule
  }

  @action exportDataStep1 = () => {
    return request.get(`${config.backend}/pgs/reports/statistics/result/excel`)
      .query({ date: this.queryMap.date })
      .checkToken()
      .commonDispose()
  }

  @action filterData = (newQueryMap) => {
    this.tableData = []
    this.updateQueryMap(newQueryMap)
    this.initOffset()
    return this.getTableData()
  }

  @action changePagin = (selectedPageNumber) => {
    this.updatePageIndex(selectedPageNumber)
    this.updateQueryMap({ offset: (selectedPageNumber - 1) * this.queryMap.limit })
    this.getTableData()
  }

  @action initOffset = () => {
    this.queryMap.offset = 0
  }

  @action updateQueryMap = (data) => {
    this.queryMap = { ...this.queryMap, ...data }
  }

  @action initPageIndex = () => {
    this.currentPageIndex = 1
  }

}


// WEBPACK FOOTER //
// ./src/app/stores/pgs/dataStatistics.js